// extracted by mini-css-extract-plugin
export default {"whyUs":"WhyUs_whyUs__tfvMx","whyUsTitle":"WhyUs_whyUsTitle__vpIv7","whyUsImage":"WhyUs_whyUsImage__1eruZ","whyUsCardContainer":"WhyUs_whyUsCardContainer__0I8-3"};